import { memo } from "react";
import type { SmartLoaderProps } from "../types";
import { CardLoader } from "./CardLoader";
import { DashboardLoader } from "./DashboardLoader";
import { ListLoader } from "./ListLoader";
import { ProfileLoader } from "./ProfileLoader";
import { ShimmerStyles } from "./ShimmerStyles";
import { TableLoader } from "./TableLoader";
import { TextLoader } from "./TextLoader";

const LOADERS = {
  card: CardLoader,
  table: TableLoader,
  dashboard: DashboardLoader,
  profile: ProfileLoader,
  list: ListLoader,
  text: TextLoader,
} as const;

export const SmartLoader = memo(function SmartLoader({
  type,
  rows,
  columns,
  animated = true,
  width,
  height,
  className,
}: SmartLoaderProps) {
  const Loader = LOADERS[type];

  return (
    <>
      <ShimmerStyles />
      <div role="status" aria-busy="true" aria-label="Loading">
        <Loader
          rows={rows}
          columns={columns}
          animated={animated}
          width={width}
          height={height}
          className={className}
        />
      </div>
    </>
  );
});
